import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    selectedBeneficary: null
};

export const beneficiarySlice = createSlice({
    name: "subscription",
    initialState,
    reducers: {
        setBeneficiary: (state, action) => {
            state.selectedBeneficary = action?.payload
        },

    },
});

export const { setBeneficiary, } = beneficiarySlice.actions;
export default beneficiarySlice.reducer;
